@if (!isLoading) {
  <div class="site-container">
    <app-navbar></app-navbar>
    <app-alert></app-alert>
    <div class="site-content">
      <router-outlet></router-outlet>
    </div>
    <app-footer></app-footer>
  </div>
} @else {
  <div class="loading-wrapper">
    <mat-progress-spinner color="primary" mode="indeterminate" diameter="32">
    </mat-progress-spinner>
  </div>
}
